// extracted by mini-css-extract-plugin
export var gif = "_k7-0";